module.exports = __webpack_public_path__ + "static/saas-banner-86cc97d93fd238ea62407d1a850a7467.jpg";